module.exports = __webpack_public_path__ + "1a1d50653ddde726f2b07631ea29b0df.png";